


if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartItems = document.querySelector("cart-items");
        this.quickViewWarpper = document.getElementById("quickViewWrapper");
        //console.log(this.cartNotification);
      }

      onSubmitHandler(evt) {
        
        //alert('click to add to cart button');
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute("disabled", true);
        submitButton.classList.add("loading");
        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);
        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          this.cartNotification.setActiveElement(document.activeElement);
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status) {
             this.handleErrorMessage(parsedState.description);
              //this.updateCartSections();
              
              return;
            }
            if (this.cartNotification) {
              this.cartNotification.renderContents(parsedState);
           
            }

            if (this.cartItems) {
              this.cartItems.renderContents(parsedState);
            }

            // Call free gift logic here
            //alert('call function check and add remove gift');
             this.checkAndAddOrRemoveFreeGift();

            document.querySelector(".product-form__error-message-wrapper")?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
            this.quickViewWarpper?.classList.remove("show__modal");
            document.body.classList.remove("overflow-hidden");
            this.AddToProductMessage();
          });
      }

      AddToProductMessage() {

        // Create main popup div
        const alertDiv = document.createElement("div");
        alertDiv.style.position = "fixed";
        alertDiv.style.top = "80px";
        alertDiv.style.left = "50%";
        alertDiv.style.transform = "translateX(-50%)";
        alertDiv.style.background = "#000";
        alertDiv.style.color = "#fff";
        alertDiv.style.padding = "10px 18px";
        alertDiv.style.borderRadius = "50px";
        alertDiv.style.display = "flex";
        alertDiv.style.alignItems = "center";
        alertDiv.style.gap = "10px";
        alertDiv.style.zIndex = "10001";
        alertDiv.style.fontSize = "14px";
        alertDiv.style.fontFamily = "sans-serif";

        // Create green circle icon container
        const iconCircle = document.createElement("div");
        iconCircle.style.width = "28px";
        iconCircle.style.height = "28px";
        iconCircle.style.background = "#03A71C";
        iconCircle.style.borderRadius = "50%";
        iconCircle.style.display = "flex";
        iconCircle.style.alignItems = "center";
        iconCircle.style.justifyContent = "center";

        // Create white tick arrow SVG
        iconCircle.innerHTML = `
            <svg width="18" height="18" viewBox="0 0 18 18" fill="white" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.30001 13.1841L3.34167 9.22574L4.33126 8.23615L7.30001 11.2049L13.6715 4.83337L14.6611 5.82296L7.30001 13.1841Z"/>
            </svg>
        `;

        // Create message text
        const msg = document.createElement("span");
        msg.textContent = "Product added to cart";

        // Append icon + text inside popup
        alertDiv.appendChild(iconCircle);
        alertDiv.appendChild(msg);

        // Append popup to body
        document.body.appendChild(alertDiv);

        // Hide after 5 seconds
        setTimeout(() => {
            alertDiv.style.transition = "0.4s";
            alertDiv.style.opacity = "0";

            setTimeout(() => {
                alertDiv.remove();
            }, 400);
        }, 5000);

        
      }

      /*updateCartSections() {
        alert('update cart sections');
        const sections = ['cart-notification-product', 'cart-items']; // Add your real section IDs here

        fetch(`${window.Shopify.routes.root}?sections=${sections.join(',')}`)
          .then(res => res.json())
          .then((data) => {
            if (this.cartNotification && data['cart-notification-product']) {
              document.getElementById('cart-notification-product').innerHTML = data['cart-notification-product'];
            }

            if (this.cartItems && data['cart-items']) {
              document.querySelector('cart-items').innerHTML = data['cart-items'];
            }
          })
          .catch(err => console.error('Failed to update cart sections:', err));
      }*/

        

      checkAndAddOrRemoveFreeGift() {
  //alert('checkout function');
  const FREE_GIFT_VARIANT_ID = 50852594745641; // Free gift product ID
  const MIN_CART_TOTAL = 999; // The threshold for free gift eligibility (in your currency)
  //alert(FREE_GIFT_VARIANT_ID);
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const total = cart.total_price / 100;
      const giftInCart = cart.items.find(item => item.variant_id === FREE_GIFT_VARIANT_ID);
      //alert(total);
      if (total >= MIN_CART_TOTAL && !giftInCart) {
        // Add free gift
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: FREE_GIFT_VARIANT_ID, quantity: 1 }
            ]
          })
        }).then(() => {
          console.log("🎁 Gift product added via PDP");
          this.updateCartPage();
        });
      } else if (total < MIN_CART_TOTAL && giftInCart) {
        // Remove gift product
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftInCart.key,
            quantity: 0
          })
        }).then(() => {
          console.log("❌ Gift product removed via PDP");
          this.updateCartPage();
          
        });
      }
    });



  }


        checkAndAddOrRemoveFreeGiftoutofstock() {
  //alert('checkout function');
  const FREE_GIFT_VARIANT_ID = 50852594745641; // Free gift product ID
  const MIN_CART_TOTAL = 999; // The threshold for free gift eligibility (in your currency)
  //alert(FREE_GIFT_VARIANT_ID);
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const total = cart.total_price / 100;
      const giftInCart = cart.items.find(item => item.variant_id === FREE_GIFT_VARIANT_ID);
      //alert(total);
      if (total >= MIN_CART_TOTAL && !giftInCart) {
        // Add free gift
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: FREE_GIFT_VARIANT_ID, quantity: 1 }
            ]
          })
        }).then(() => {
          console.log("🎁 Gift product added via PDP");
          this.updateCartPage();
          location.reload();
        });
      } else if (total < MIN_CART_TOTAL && giftInCart) {
        // Remove gift product
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftInCart.key,
            quantity: 0
          })
        }).then(() => {
          console.log("❌ Gift product removed via PDP");
          this.updateCartPage();
          location.reload();
        });
      }
      else{
        location.reload();
      }
    });



  }

  updateCartPage() {
    // Fetch the content of the cart notification section every 5 seconds
    fetch('/cart-notification-url')  // Replace with the URL that returns the cart-notification-product
    .then(response => response.text())  // Get the response as text (HTML content)
    .then(data => {
      // Find the part of the response that contains the cart notification product
      const cartNotification = new DOMParser().parseFromString(data, 'text/html');
      
      // Extract the HTML of the cart notification
      const cartNotificationContent = cartNotification.querySelector('#cart-notification-product');

      // Now update your current DOM with the new content
      if (cartNotificationContent) {
        document.getElementById('cart-notification-product').innerHTML = cartNotificationContent.innerHTML;
      }
    })
    .catch(error => console.log('Error fetching cart notification:', error));
  }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
         
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
         
         this.checkAndAddOrRemoveFreeGiftoutofstock();
         
         
         //this.cartNotification.open();
         document.getElementById("min-cart-items").classList.remove("no-js-inline");
         const emptyCartItem = document.querySelector(".empty__cart__item");
          if (emptyCartItem) {
              emptyCartItem.classList.add("no-js-inline");
          }
         
         
         //location.reload();

      }


    }
  );
}
